
function Imprint() {

    return (
        <div className="content">
            <article>
                <h1>Impressum</h1>
                <p><strong>Angaben gemäß § 5 TMG:</strong></p>
                <p>Anne Hensel<br />
                Marienthaler Str. 47<br />
                20535 Hamburg</p>

                <p><strong>Kontakt:</strong></p>
                <p>E-Mail: info@apartment5-wismar.de</p>

                <p><strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong></p>
                <p>Anne Hensel<br />
                Marienthaler Str. 47<br />
                20535 Hamburg</p>

                <p><strong>Haftungsausschluss:</strong></p>
                <p>Die Inhalte dieser Seite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
                    Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                </p>
                <p>Für Links auf externe Websites übernehmen wir keine Haftung, da wir keinen Einfluss auf 
                    deren Inhalte haben. Verantwortlich für den Inhalt der verlinkten Seiten ist stets der 
                    jeweilige Anbieter oder Betreiber der Seiten. Die permanente Überwachung fremder Inhalte
                    auf Rechtsverstöße ohne konkrete Hinweise ist uns nicht zumutbar. Sollten wir Kenntnis
                    von Rechtsverletzungen erlangen, werden wir die entsprechenden externen Links unverzüglich
                    entfernen.
                </p>
                <p>Wir sind eine unabhängige dritte Partei, die nicht von Airbnb, Inc. oder seinen 
                    Tochtergesellschaften unterstützt wird oder mit ihnen verbunden ist. Buchungen erfolgen
                    ausschließlich über Airbnb, wir bieten keine eigenen Buchungssysteme über die Website an.
                </p>
                <p>Alle auf dieser Website verwendeten Fotos wurden mit freundlicher Genehmigung der Urheber 
                    erstellt. Eine weitere Nutzung der Bilder ist ohne ausdrückliche Zustimmung der Urheber 
                    nicht gestattet.
                </p>
                <p><strong>Einbindung von Diensten Dritter</strong></p>
                <p>Wir setzen innerhalb unseres Onlineangebotes auf Grundlage des berechtigten Interesses im 
                    Sinne des Art. 6 Abs. 1 lit. f. DSGVO Serviceangebote von Drittanbietern ein, um deren 
                    Services, wie z.B. Schriftarten, einzubinden.<br />
                    Wir binden die Schriftarten (“Google Fonts”) des Anbieters Google LLC, 1600 Amphitheatre 
                    Parkway, Mountain View, CA 94043, USA, ein. Datenschutzerklärung: {/*
                    */}<a href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a>, 
                    Opt-Out: <a href="https://adssettings.google.com/authenticated">https://adssettings.google.com/authenticated</a>.
                    </p><br />
                <h3>Datenschutzerklärung</h3>
                <p><strong>Verantwortlicher</strong></p>
                <p>Anne Hensel<br />
                    Marienthaler Str. 47<br />
                    20535 Hamburg</p>
                <p><strong>Hosting der Website</strong></p>
                <p>Diese Webseite wird bei folgendem Anbieter gehostet:<br />
                    STRATO GmbH<br />
                    Otto-Ostrowski-Straße 7<br />
                    10249 Berlin<br />
                </p>
                <p>Beim Besuch dieser Webseite werden durch den Hosting-Anbieter automatisch folgende Daten in
                    sogenannten Server-Logfiles erhoben:<br />
                    Domain, Anonymisierte Client-IP, Request-Zeile, Timestamp, Status Code, Größe des Response 
                    Bodies, Referer, der vom Client gesendet wurde, User Agent, der vom Client gesendet wurde, 
                    Remote User.<br />
                    Die Speicherung erfolgt aus Sicherheitsgründen, um z. B. Angriffe auf die Webseite 
                    erkennen und abwehren zu können. Die Logfiles werden nach maximal sieben Tagen gelöscht. STRATO  
                    stützt sich dabei auf die Rechtsgrundlage der berechtigten Interessen, Art. 6 Abs. 1 lit. f 
                    DSGVO.</p>
                <p><strong>Weiterleitung zu Airbnb</strong></p>
                <p>Auf dieser Webseite finden Sie Links zur Plattform Airbnb. Beim Anklicken dieser Links werden 
                    Daten (wie Ihre IP-Adresse) an Airbnb übertragen. Für die Datenverarbeitung auf Airbnb gelten 
                    deren Datenschutzbestimmungen, die Sie hier einsehen können: {/*
                    */}<a href="https://www.airbnb.de/help/article/3175/">https://www.airbnb.de/help/article/3175/</a>. 
                </p>
                <p><strong>Rechte der Betroffenen</strong></p>
                <p>Sie haben das Recht auf: Auskunft über die Verarbeitung Ihrer Daten, Berichtigung oder Löschung Ihrer 
                    Daten, Einschränkung der Verarbeitung, Widerspruch gegen die Verarbeitung Ihrer Daten, 
                    Datenübertragbarkeit.</p>
                <p><strong>Beschwerderecht</strong></p>
                <p>Falls Sie der Meinung sind, dass die Verarbeitung Ihrer Daten gegen die DSGVO verstößt, können Sie 
                    sich bei der zuständigen Datenschutzbehörde beschweren.</p>
            </article>
        </div>
    );
}

export default Imprint;